import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { getBookingToRightDataAction } from "../Booking/GetBookingToRightDataAction";
import { loadBookingAppearanceMinutes } from "../../../Lib/Utils/bookingAppearancePeriod";

class GetBookingDetailOfRetrieveBookingAction extends BaseAction<IDefaultActionResult, void> {
    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: [],
            message: "",
            status: "fail"
        }
        try {
            const retrieveBookingCashData: any = localStorage.getItem("retrieveBookingCacheData")
            if (retrieveBookingCashData) {
                const rbObject = JSON.parse(retrieveBookingCashData)
                if (rbObject.retrieveBooking) {
                    const isBookingPast = rbObject?.retrieveBooking?.isPastBooking || false
                    const cachedActiveTab = rbObject?.retrieveBooking?.activeTab
                    const activeTab = cachedActiveTab === "2" ? "2" : cachedActiveTab === "1" ? "1" : (isBookingPast ? "2" : "1")
                    const retrieveBooking: any = {
                        id: rbObject.retrieveBooking.bookingId,
                        isRetrieveBooking: true
                    }
                    // Settle the appearance period BEFORE the pivots inside
                    // getBookingToRightDataAction read it synchronously. Every
                    // other route into that action is warmed by the tab action
                    // or the month filter; this one — a reload landing straight
                    // on a cached PNR — is not, and it races ClientProvider's
                    // TOKEN_READY warm. Losing that race would filter the
                    // booking with the fallback period while `activeTab` above
                    // was decided with the real one, and the booking would show
                    // in neither tab.
                    await loadBookingAppearanceMinutes();

                    getBookingToRightDataAction.setParams({
                        bookedTrips: [retrieveBooking],
                        activeTab,
                        isAnonymous: true
                    });
                    await getBookingToRightDataAction.execute();
                    updateRecoilState("showRetrieveBookingAtom", false)
                    updateRecoilState("activeBookingTabAtom", activeTab)
                }
            } else {
                actionResult.message = "Reference or last name must be required"
            }
        } catch (error) {
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const getBookingDetailOfRetrieveBookingAction = new GetBookingDetailOfRetrieveBookingAction()
